import { styled } from '@/stitches.config';
import { Canvas } from '@react-three/fiber';

interface R3fCanvasProps {
  children: React.ReactNode;
}

export function R3fCanvas({ children }: R3fCanvasProps) {
  return (
    <CanvasContainer>
      <Canvas>{children}</Canvas>
    </CanvasContainer>
  );
}

const CanvasContainer = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100vh',
  minHeight: '-webkit-fill-available',
  width: '100%',
  zIndex: -1,
});
